import React from 'react';
import { node, oneOf, string } from 'prop-types';
import classnames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { uppercase } from './styles.ve.css';

const COLORS = {
    pink: 'pink_700',
    blue: 'blue_700',
};

const TagLabel = ({ children, color, variant = 'filled', className, ...props }) => {
    const colorToken = COLORS[color];
    const isFilled = variant === 'filled';

    return (
        <Container
            as="span"
            className={classnames(uppercase, className)}
            display="inlineFlex"
            alignItems="center"
            justifyContent="center"
            height="17px"
            paddingX="1.5"
            borderWidth="sm"
            borderStyle="solid"
            borderColor={colorToken}
            borderRadius="circle"
            backgroundColor={isFilled ? colorToken : 'white'}
            color={isFilled ? 'white' : colorToken}
            fontSize="b_xxs"
            lineHeight="b_xxs"
            fontWeight="bold"
            {...props}
        >
            {children}
        </Container>
    );
};

TagLabel.propTypes = {
    children: node.isRequired,
    color: oneOf(Object.keys(COLORS)).isRequired,
    variant: oneOf(['filled', 'outline']),
    className: string,
};

export default TagLabel;
